module.exports = __webpack_public_path__ + "img/parley.58fc004f.gif";